import React from "react";
import '../../style_new.css';

const About = () => {
  return (
    <>
      {/* about section start */}
      <div className="container-xxl py-5">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <div
                className="position-relative overflow-hidden ps-5 pt-5 h-100"
                style={{ minHeight: "400px" }}
              >
                <img
                  className="position-absolute w-100 h-100"
                  src="./images/about.jpg"
                  alt="about-us"
                  style={{ objectFit: "cover" }}
                />
                <div
                  className="position-absolute top-0 start-0 bg-white pe-3 pb-3"
                  style={{ width: "200px", height: "200px" }}
                >
                  <div className="d-flex flex-column justify-content-center text-center bg-primary h-100 p-3">
                    <h1 className="text-white">14</h1>
                    <h2 className="text-white">Years</h2>
                    <h5 className="text-white mb-0">Experience</h5>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.5s">
              <div className="h-100">
                <div className="border-start border-5 border-primary ps-4 mb-4">
                  <h6 className="text-body text-uppercase mb-2">About Us</h6>
                  <h1 className="display-6 mb-0">
                    Unique Solutions For Residentials & Industries!
                  </h1>
                </div>

                <p>
                  Fair Vision Ventures Limited was incorporated as a private limited liability company under the Companies Code 1963 (Act 179) on 13th January, 2010. The company originally began as a sole proprietorship in 2009 and evolved into a limited liability structure just a year later to better serve the growing demands of the construction sector in Ghana.
                </p>

                <p>
                  Headquartered at Number 25, 7th Crescent Section 2, Atasemanso – Kumasi, the company now employs over 40 skilled and semi-skilled workers who contribute across various departments including civil engineering, architecture, procurement, and project management. Our core focus lies in the delivery of reliable, quality-assured building and civil engineering solutions tailored to both private and public sector clients.
                </p>

                <p>
                  Our team brings a dynamic combination of local expertise and modern building practices, allowing us to exceed expectations on projects ranging from residential homes to large-scale infrastructure. Through strong leadership and a focus on client satisfaction, Fair Vision Ventures has built a reputation for consistency, safety, and innovation over the past decade.
                </p>

                <div className="mt-4">
                  <h5 className="text-primary">Vision</h5>
                  <p>
                    To become the reference point in the building and civil engineering industry in Ghana within the next ten years.
                  </p>

                  <h5 className="text-primary">Mission</h5>
                  <p>
                    To employ modern technology and innovation in the execution of various building and civil works, achieving the highest quality output to the delight of our clients.
                  </p>
                </div>

                <div className="border-top mt-4 pt-4">
                  <div className="row g-4">
                    <div className="col-sm-4 d-flex wow fadeIn" data-wow-delay="0.1s">
                      <i className="fa fa-check fa-2x text-primary flex-shrink-0 me-3"></i>
                      <h6 className="mb-0">Ontime at services</h6>
                    </div>
                    <div className="col-sm-4 d-flex wow fadeIn" data-wow-delay="0.3s">
                      <i className="fa fa-check fa-2x text-primary flex-shrink-0 me-3"></i>
                      <h6 className="mb-0">24/7 hours services</h6>
                    </div>
                    <div className="col-sm-4 d-flex wow fadeIn" data-wow-delay="0.5s">
                      <i className="fa fa-check fa-2x text-primary flex-shrink-0 me-3"></i>
                      <h6 className="mb-0">Verified professionals</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* about section end */}
    </>
  );
};

export default About;
